import cn from 'classnames';
import { useLocation, useNavigate } from 'react-router-dom';
import { EventVisitorMenu } from '@widgets/events';
import { Header } from '@features/events';
import { ItemInfo, Person } from '@features/events/common/information';
import { ItemWithAction } from '@features/events/event-visitor/item-with-action/ui';
import { useVisitor } from '@features/events/event-visitor/model';
import { ArrowShortLeft, Moderation } from '@shared/assets';
import { Card, IconButton, ListBody } from '@shared/ui';
import * as st from './styles.module.scss';

export const VisitorPage = (): JSX.Element => {
  const navigate = useNavigate();
  /**
   * TODO: Получить реальные данные, убрать хардкод;
   */
  const {
    firstName,
    middleName,
    lastName,
    isPaidFull,
    cost,
    alreadyPayed,
    onBuy,
    onExclude,
    onClose,
    visitorId,
  } = useVisitor();

  const status = isPaidFull ? 'Оплачено' : 'Частично оплачено';
  const isExclude = false;
  const debt = cost - Number(alreadyPayed);

  const acceptPay = (): JSX.Element => (
    <button className={st.paid__accept} onClick={onBuy}>
      Принять оплату
    </button>
  );

  const renderRefund = (): JSX.Element => (
    <div className={st.refund}>
      <span className={st.refund__text}>Возврат средств</span>
      <Moderation />
    </div>
  );

  const handleClickNavigate = () => {
    localStorage.setItem('toBackVisitor', location.pathname);
    navigate(`/events/events/client/${visitorId}`);
  };

  return (
    <>
      <Header
        title="Участник"
        left={
          <IconButton variant="dark" onClick={onClose}>
            <ArrowShortLeft />
          </IconButton>
        }
        right={<EventVisitorMenu onExclude={onExclude} />}
      />
      <ListBody className={st.body}>
        <section className={st.visitor}>
          <div className={st.body}>
            <Card className={st.card}>
              <div className={st.visitor__head}>
                <span className={st.title}>Участник</span>
                <Person
                  firstName={firstName}
                  middleName={middleName}
                  lastName={lastName}
                  status={() => (isExclude ? renderRefund() : <></>)}
                  onNavigate={handleClickNavigate}
                />
              </div>
              <div className={st.visitor__body}>
                <ul className={st.list}>
                  {status && (
                    <ItemInfo
                      className={cn(isPaidFull ? st.paid__full : st.paid__part)}
                      title="Статус"
                      value={status}
                    />
                  )}
                  <ItemInfo
                    title="Стоимость"
                    value={cost / 100}
                    suffix="RUB"
                    suffixClass={st.item__suffix}
                  />
                  <ItemInfo
                    title="Оплачено"
                    value={alreadyPayed / 100}
                    suffix="RUB"
                    suffixClass={st.item__suffix}
                  />
                  {!isPaidFull && (
                    <ItemWithAction
                      className={cn(isPaidFull ? st.paid__full : st.paid__part)}
                      title="К оплате"
                      value={debt / 100}
                      suffix="RUB"
                      suffixClass={st.item__suffix}
                      action={() => acceptPay()}
                    />
                  )}
                </ul>
              </div>
            </Card>
          </div>
        </section>
      </ListBody>
    </>
  );
};
